import { useQuery } from "react-query";

import { getAllPlatformData } from "api/dashboardBackend";
import type { PlatformDataResponse } from "api/dashboardBackend";
import { useSource } from "components/SourceContext";

const usePlatformData = () => {
  const source = useSource();
  return useQuery<PlatformDataResponse[]>({
    queryFn: () => {
      const params = new URLSearchParams();
      if (source !== null) {
        params.set("source", source);
      }
      return getAllPlatformData(params);
    },
    queryKey: ["platformData", source],
  });
};

export default usePlatformData;
